// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"layouts_Breadcrumb__qFdpA"};